import React from 'react';
import { AgentGroup, AgentType } from './types';

interface AlertProps {
  userType: AgentType;
  defaultAgentGroup: AgentGroup;
  offerCount: number;
}

const Alert: React.FunctionComponent<AlertProps> = ({
  userType,
  defaultAgentGroup,
  offerCount,
}) => {
  if (userType === 'admin') {
    return (
      <>
        <div
          className="alert alert-danger offer-registration-modal-alert-admin"
          role="alert"
        >
          {defaultAgentGroup === 'all' && (
            <p>
              The listing is set up so that <strong>ALL SHOWING AGENTS</strong>{' '}
              get notified when an offer gets registered.
            </p>
          )}
          {defaultAgentGroup === 'registered' && (
            <p>
              The listing is set up so that only
              <strong>AGENTS WITH REGISTERED OFFERS</strong> get notified when
              an offer is registered.
            </p>
          )}
          {defaultAgentGroup === 'none' && (
            <p>
              The listing is set up so that only the{' '}
              <strong>LISTING AGENT</strong> gets notified when an offer is
              registered. The listing agent will choose when to notify other
              agents.
            </p>
          )}
        </div>
      </>
    );
  }
  if (userType === 'agent') {
    return (
      <div className="offer-registration-modal-alert-la">
        Who would you like to notify regarding the # of offers ({offerCount})
        registered on your listing?
      </div>
    );
  }
  return null;
};

export default Alert;
